export const planConfigs = {
  Basic: {
    limits: {
      projects: 1,
      pages: 3000
    },
    features: {
      dashboard: true,
      custom_integrations: false,
      data_retention_days: 7,
      support_type: 'email',
      monthly_credits: 3,
      max_tokens_per_analysis: 10000000
    }
  },
  Guru: {
    limits: {
      projects: 4,
      pages: 20000
    },
    features: {
      dashboard: true,
      custom_integrations: false,
      data_retention_days: 30,
      support_type: 'chat',
      monthly_credits: 50,
      max_tokens_per_analysis: 20000000
    }
  },
  Pro: {
    limits: {
      projects: 8,
      pages: 80000
    },
    features: {
      dashboard: true,
      custom_integrations: true,
      data_retention_days: 90,
      support_type: 'priority_chat',
      monthly_credits: 150,
      max_tokens_per_analysis: 40000000
    }
  },
  Business: {
    limits: {
      projects: "Unlimited",
      pages: "Unlimited"
    },
    features: {
      dashboard: true,
      custom_integrations: true,
      data_retention_days: "Unlimited",
      support_type: 'dedicated',
      monthly_credits: 1000,
      max_tokens_per_analysis: 80000000
    }
  }
};

export const checkFeatureAccess = (userPlan, feature) => {
  const planConfig = planConfigs[userPlan];
  if (!planConfig) return false;
  return planConfig.features[feature] || false;
};

export const getDataRetentionDays = (userPlan) => {
  const planConfig = planConfigs[userPlan];
  if (!planConfig) return 7; // default to Basic plan retention
  return planConfig.features.data_retention_days;
};

export const getSupportType = (userPlan) => {
  const planConfig = planConfigs[userPlan];
  if (!planConfig) return 'email';
  return planConfig.features.support_type;
}; 